import React from "react";

import * as R from "ramda";
import { componentFromProp, withProps } from "recompose";

import { Box } from "src/components/base";
import { Divider, sideForIndex } from "src/components";

import Embed, { isActiveArticle } from "src/components/Embed";
import ItemGroup from "src/components/ItemGroup";
import Bio from "./Bio";
import Body from "./Body";
import BanzaiCalculator from "./BanzaiCalculator";
import Calculator from "./Calculator";
import Module from "./Module";

const contentTypes = {
  ContentfulItemGroup: ItemGroup,
  ContentfulArticle: Embed,
  ContentfulPage: Embed,
  ContentfulBody: Body,
  ContentfulBio: Bio,
  ContentfulBanzaiCalculator: BanzaiCalculator,
  ContentfulCalculator: Calculator,
  ContentfulModule: Module,
};

const ContentComponent = withProps(
  R.pipe(
    R.prop("__typename"),
    R.propOr("div", R.__, contentTypes),
    R.objOf("component")
  )
)(componentFromProp("component"));

const filterContent = content => {
  if (content.__typename === "ContentfulArticle") {
    return isActiveArticle(content);
  }

  return true;
};

export default ({
  condensed = false,
  dividers = true,
  content,
  theme,
  siteData,
  pageData,
}) => (
  <Box>
    {R.filter(filterContent, content).map(
      (contentType, index) =>
        contentType
          ? [
              <ContentComponent
                key={contentType.id}
                parentTheme={theme}
                siteData={siteData}
                padded={!condensed}
                pageData={pageData}
                {...contentType}
              />,
              dividers &&
                !condensed &&
                index !== content.length - 1 && (
                  <Divider key="divider" side={sideForIndex(index)} />
                ),
            ]
          : null
    )}
  </Box>
);



// WEBPACK FOOTER //
// ./src/components/Content/Content.js